import React from "react";
import { Box } from "@material-ui/core";

export default function RTL({ children, dir }) {
  return <Box dir={dir}>{children}</Box>;
}
